export default __webpack_public_path__ + "static/media/runnerup4.961db293.jpg";